// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4cd77f13","609":"c06fd596","625":"f5641c1a","649":"54893cbb","652":"1b374ac7","674":"8ecb2fbd","863":"e1abff33","872":"56235825","900":"86e14a95"}[chunkId] + ".chunk.js";
};